<template>
  <div>
    <template v-if="easypaisa_dashboard === true">
    <div>
        <div class="page-top mb-1 mb-3 clearfix">
            <h1 class="float-left">{{this.$route.params['companyName']}}</h1>
        </div>
        <div class="tab-content" id="myTabContent">
            <div>
               <div class="mt-3 mb-3 tbl-fiters-search-area  hidden-xs">
                    <div class="field-box export-records">
                        <button class="btn btn-primary export" @click="exportDetail">Export Detail</button>
                    </div>
               </div>


<!--                <div class="tab-pane fade show active" id="" role="tabpanel" aria-labelledby="new-tab">-->
<!--                    <div class="table-holder p-2">-->
<!--                    <table id="EPDashboardDetailTable" class="table" style="width:100%">-->
<!--                        <thead>-->
<!--                        <tr>-->
<!--                            <th>Name</th>-->
<!--                            <th>Phone#</th>-->
<!--                            <th>Amount</th>-->
<!--                            <th>Acount type</th>-->
<!--                            <th>Account #</th>-->
<!--                            <th>Txn ID </th>-->
<!--                            <th>Date </th>-->

<!--                        </tr>-->
<!--                        </thead>-->
<!--                        <tbody>-->
<!--                        <tr v-for="transaction in transactions" >-->
<!--                            <td>{{transaction.name}}</td>-->
<!--                            <td>{{transaction.mobileNo}}</td>-->
<!--                            <td>{{transaction.net_salary}}</td>-->
<!--                            <td>{{transaction.account_type}}</td>-->
<!--                            <td>{{transaction.account_number}}</td>-->
<!--                            <td>{{transaction.transactionId}}</td>-->
<!--                            <td>{{transaction.date}}</td>-->
<!--                        </tr>-->
<!--                        </tbody>-->
<!--                    </table>-->
<!--                    </div>-->
<!--                </div>-->
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="label block-label"> From Date </label>
                    <datepicker name="from_date" v-model="from_date" input-class="datepicker" :bootstrap-styling="true" placeholder="From Date"></datepicker>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="label block-label"> To Date </label>
                    <datepicker name="to_date" v-model="to_date" input-class="datepicker" :bootstrap-styling="true" placeholder="To Date"></datepicker>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group align-right">
                    <br>
                    <button @click="getEPDashboardCompanyPaymentsDetailReport" v-if="!showBtn"  class="btn btn-primary">Submit</button>
                    <button @click="filterTable" v-if="showBtn"  class="btn btn-primary">Submit</button>
                  </div>
                </div>
              </div>
              <div class="row ml-2">
                <div class="searching float-right mr-2">
                  <input id="customSearch" type="text" class="form-control search" name="" />
                </div>
              </div>
              <div class=" p-2">
                <table id="dt-table" class="table" style="width:100%">
                  <thead>
                  <tr class="align-centre">
                    <th>Name</th>
                    <th>Phone#</th>
                    <th>Amount</th>
                    <th>Acount type</th>
                    <th>Account #</th>
                    <th>Txn ID </th>
                    <th>Date </th>
                  </tr>
                  </thead>
                </table>
              </div>
            </div>
        </div>
    </div>
    </template>
    <template v-else-if="easypaisa_dashboard === null"><preLoader></preLoader></template>
    <template v-else-if="easypaisa_dashboard === false">
      <notAllowed></notAllowed>
    </template>
  </div>
</template>


<script>
    var dtTable = null;
    export default {
        data() {
            return {
              easypaisa_dashboard: null,
              transactions:{},
              from_date : '',
              to_date : '',
            };
        },
        mounted() {
          this.can('easypaisa_dashboard').then(result => {
            if (result.easypaisa_dashboard) {
              this.easypaisa_dashboard = result.easypaisa_dashboard;
            }
            // this.account_balance = result.vr_balance;
          }).then(result => {
            if(this.easypaisa_dashboard == true){
              this.getEPDashboardCompanyPaymentsDetailReport();
            }
          });

        },
        methods: {
          filterTable(){
            this.$Progress.start();
            dtTable.draw();
            this.$Progress.finish();
          },
          getEPDashboardCompanyPaymentsDetailReport: function(){
            this.$Progress.start();
            var that = this;
            var companyId = that.$route.params['companyId'];
            dtTable = $('#dt-table').DataTable({
              sDom: '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
              processing: true,
              serverSide: true,
              pageLength: 20,
              searching :true,
              buttons: [],
              ajax: {
                "url": "/api/getEPDashboardCompanyPaymentsDetailReport?companyId="+companyId,
                "data": function (d) {
                  d.from_date = moment(that.from_date).format('YYYY-MM-DD');
                  d.to_date = moment(that.to_date).format('YYYY-MM-DD');
                },
                "headers": window.axios.defaults.headers.common,
                "dataSrc": "records",
              },
              deferRender: true,
              columns: [

                {render: function(data,type,full){
                    if(full.name != null){
                      return full.name;
                    }else{
                      return "---";
                    }
                  }},
                {render: function(data,type,full){
                    if(full.mobileNo != null){
                      return full.mobileNo;
                    }else{
                      return "---";
                    }
                  }},
                {render: function(data,type,full){
                    if(full.net_salary != null){
                      return full.net_salary;
                    }else{
                      return "---";
                    }
                  }},
                {render: function(data,type,full){
                    if(full.account_type != null){
                      return full.account_type;
                    }else{
                      return "---";
                    }
                  }},
                {render: function(data,type,full){
                    if(full.account_number != null){
                      return full.account_number;
                    }else{
                      return "--";
                    }
                  }},
                {render: function(data,type,full){
                    if(full.transactionId != null){
                      return full.transactionId;
                    }else{
                      return "--";
                    }
                  }},
                {render: function(data,type,full){
                    if(full.updated_at != null){
                      return full.updated_at;
                    }else{
                      return "---";
                    }
                  }},
              ],
              "order": [[ 0, "desc" ]],
              "initComplete": (res) => {
                that.hasPer = true;
                that.showBtn = true;
                setTimeout(function(){
                  $('select.selectpicker').selectpicker();
                },300);
                that.$Progress.finish();
              }
            });
            $('#customSearch').on( 'keyup', function () {
              dtTable.search(this.value).draw();
            });
          },
            exportDetail: function(){
                console.log(this.$route.params['companyId']);
                var that = this;
                that.$Progress.start();
                var formData = {
                    'from_date': moment(this.from_date).format('YYYY-MM-DD'),
                    'to_date': moment(this.to_date).format('YYYY-MM-DD'),
                    'companyId': this.$route.params['companyId'],
                }
                axios.post('/api/epDashboardDetailExport', formData,{
                    responseType: 'blob'
                })
                    .then(res => {
                        if(res.status == 200){
                            const url = URL.createObjectURL(new Blob([res.data], {
                                type: 'application/vnd.ms-excel'
                            }))

                            const link = document.createElement('a')
                            link.href = url
                            link.setAttribute('download', 'CompanyTransactionsDetail.xls')
                            document.body.appendChild(link)
                            link.click()
                            //that.$Progress.finish();
                        }else{
                            //that.$Progress.fail();
                            that.showAlertBox('error','Error to load data');
                        }
                    })
                    .catch(err => {
                        //that.$Progress.fail();
                        that.showAlertBox('error','Error to load data');
                    });
            },
        },
        created() {
            //
        }
    }
</script>
